import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=37757c05&scoped=true"
import script from "./TabTitle.vue?vue&type=script&lang=js"
export * from "./TabTitle.vue?vue&type=script&lang=js"
import style0 from "./TabTitle.vue?vue&type=style&index=0&id=37757c05&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37757c05",
  null
  
)

export default component.exports